import { useEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useGetCategoryQuery, useAddCatalogMutation, useDeleteCatalogMutation } from '../store/api/directory/categoryApi';
import { Card } from 'primereact/card';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import PresortDemo from '../components/table/DataTable';
import { useAddCountryMutation, useGetCountryQuery } from '../store/api/directory/countryApi';
import { useAddCurrencyMutation, useGetCurrencyQuery } from '../store/api/directory/currencyApi';
import { useGetRegionQuery } from '../store/api/directory/regionApi';
import { useGivePermissionMutation, useGetWarehouseQuery } from '../store/api/directory/warehouse';
import { Sidebar } from 'primereact/sidebar';
import Editor from '../components/UI/editor';
import MyButton from '../components/UI/Button';
import { Toast } from "primereact/toast";
import { adressColumn, categoryColumn, warehouseColumn } from '../metadata/directory';
import { SpeedDial } from 'primereact/speeddial';
import { useNavigate, useParams } from 'react-router-dom';

export default function Warehouse() {
	const { employeeGuid = null } = useParams();
	const navigate = useNavigate();
	const [selectedProducts, setSelectedProducts] = useState(null);
	const [rowClick, setRowClick] = useState(true);
	const toast = useRef(null);
	const { data: warehouse = [], isLoading, error } = useGetWarehouseQuery(employeeGuid);
	const [givePerm] = useGivePermissionMutation()

	useEffect(() => {
		setSelectedProducts(warehouse.warehouse_user)
	}, [warehouse])
	const givePermission = (id) => {
		confirmDialog({
			message: 'Подтвердите свои действия?',
			header: 'Подтверждение',
			icon: 'pi pi-exclamation-triangle',
			accept: async () => {
				givePerm({
					employeeGuid: employeeGuid,
					warehouse: selectedProducts.map(item => item.guid)
				})
			},
		});
	};

	const [formData, setFormData] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		if (data?.status == 3 || data?.status == 16) {
			return
		}
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}



	return (
		<>
			<SpeedDial
				model={[]}
				radius={120}
				type="quarter-circle"
				onClick={() => {
					givePermission()
				}}

				direction="up-left"
				style={{ right: 15, bottom: 15 }}
			/>
			<Toast ref={toast} />



			<PresortDemo
				selectionMode={'checkbox'}
				selection={selectedProducts}
				selectionMode="multiple"
				onSelectionChange={(e) => setSelectedProducts(e.value)}
				isLoading={isLoading}
				data={warehouse.result ?? []}
				column={warehouseColumn}
				toggleSidebar={() => { }}
				deleteHandler={(row, field) => {
					console.log(row, field);
				}}
				actions={[]}
			/>
		</>
	);
}
